// react
import { useState, useEffect } from "react";
import { useParams, useLocation } from "react-router-dom";
// common
import PageLayout from "../../../common/shell/PageLayout";
import TaskLayout from "../../../common/shell/TaskLayout";
// me
import { IRootViewModel, RootViewModel } from "./models/models";
import * as actions from "./actions";
import DetailsView from "./views/DetailsView";
import * as licenceDetailsHelper from "./licenceDetailsHelper";

interface IRouteParameters {
    licenceId: string;
}

export default function Controller() {
    const { licenceId } = useParams<IRouteParameters>();
    // initial state
    const [vm, setVm] = useState<IRootViewModel>(new RootViewModel());
    const [hasAutomationRun, setHasAutomationRun] = useState(false);

    // on mount
    useEffect(() => {
        actions.initialise(Number(licenceId), setVm);

        // reset state when route changes
        return () => {
            setVm(new RootViewModel());
        };
    }, [licenceId]);

    // automation requests
    const location = useLocation();
    const params = new URLSearchParams(location.search);
    const tab = licenceDetailsHelper.getPreferredTab(params);
    useEffect(() => {
        if (!vm.licenceId) return; // only allow automation to run after the page has initialised
        if (hasAutomationRun) return; // only run automation once

        licenceDetailsHelper.tryOpenLicenceMemorialDocument(vm, params);
        setHasAutomationRun(true);
    }, [vm.licenceId, hasAutomationRun]); // eslint-disable-line react-hooks/exhaustive-deps

    return (
        <PageLayout title={[vm.summary?.licenceTypeDescription, vm.summary?.licenceNumber]}>
            <TaskLayout isBusy={vm.isBusy} error={vm.error}>
                <DetailsView vm={vm} preferredTab={tab} />
            </TaskLayout>
        </PageLayout>
    );
}
